import { createRouter, createWebHistory } from 'vue-router'
import ContactView from '../views/ContactView.vue'
import TicketView from '../views/TicketView.vue'
import PartyView from '../views/PartyView.vue'
import Home from '../views/HomePage.vue'
import RulesPage from '../views/RulesPage.vue'
// import EventPage from '../views/EventPage.vue'
import GalleryPage from '../views/GalleryPage.vue'
import AdminBookingView from '../views/AdminBookingView.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  {
    path: '/ticket',
    name: 'ticket',
    component: TicketView
  },
  {
    path: '/party',
    name: 'party',
    component: PartyView
  },
  {
    path: '/rules',
    name: 'Rules',
    component: RulesPage
  },
  {
    path: '/galleries',
    name: 'Gallery',
    component: GalleryPage
  },
  // {
  //   path: '/event',
  //   name: 'Event',
  //   component: EventPage
  // },
  {
    path: '/admin/bookings',
    name: 'AdminBookings',
    component: AdminBookingView,
    meta: {
      hideInNav: true
    }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router 